import { Form, Input, Button, message } from "antd";
import mockup from "../../../../public/images/login-mockup.png";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import { useSignIn } from "../../../hooks/useAuth";
import { Logo } from "../../../icons";

const LoginPage = () => {
  const navigate = useNavigate();

  const { mutateAsync: signIn, status } = useSignIn();
  const isLoading = status === "pending";

  const onFinish = (values: any) => {
    signIn({ user_name: values.username, password: values.password });
  };

  return (
    <div className="login-page">
      {/* Left Decorative Panel */}
      <div className="login-info-panel">
        <div className="info-header">
          <Logo width={142} height={32} />
          <div className="info-content">
            <h1>Empowering Field Teams for Seamless Operations</h1>
            <p className="subtitle">Simplified, Smart, Efficient</p>
          </div>
        </div>
        {/* This is a placeholder for the decorative card image */}
        <div className="info-card-placeholder">
          <img src={mockup} alt="App preview" className="card-image" />
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="login-form-panel">
        <div className="form-container">
          <h2>Welcome Back!</h2>
          <p className="form-subtitle">
            Login with your email ID or mobile number and password
          </p>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please input your Email or Mobile!",
                },
              ]}
            >
              <Input
                placeholder="Email/Mobile number"
                className="login-input"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your Password!" },
              ]}
            >
              <Input.Password
                type="password"
                placeholder="Password"
                className="login-input"
              />
            </Form.Item>
            <Form.Item>
              <a className="login-form-forgot" href="forgot">
                Forgot password?
              </a>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                {isLoading ? "Logging in..." : "LOGIN"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
